import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogBoxComponentDimension } from './dialog/dialog-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { DimensionRiesgosService } from '../../services/dimensiones-riesgos.service';
import { DimensionRiesgo } from 'app/main/models/dimension-riesgo.model';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { MatPaginator, PageEvent } from "@angular/material/paginator";


const ELEMENT_DATA: DimensionRiesgo[] = [];

@Component({
    selector   : 'dimensiones-riesgos',
    templateUrl: './dimensiones-riesgos.component.html',
    styleUrls  : ['./dimensiones-riesgos.component.scss']
})
export class DimensionesRiesgosComponent
{
    displayedColumns: string[] = ['nombre','descripcion','categorias','action'];
    dataSource = ELEMENT_DATA;
    isAdmin  = false;
    basicSlice = 10;
    elementCount = 0;

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    

    constructor(public dialog: MatDialog,
                private tokenStorage: TokenStorageService,
                private service: DimensionRiesgosService) {}

    ngOnInit() {
      this.paginator._intl.itemsPerPageLabel="Ítems por página";
      this.service.count().subscribe(req => {
        this.elementCount = req.body;
      });
      this.getElements(0);

      var role = this.tokenStorage.getRole();
      for(var i=0;i<role.length;i++){
        //Admin o Especialista en riesgos
        if(role[i]==2 || role[i]==5)
          this.isAdmin = true;
      }
    }

    getElements(page):void{
      this.service.getAll(page,this.basicSlice).pipe().subscribe(req => {
        this.dataSource = req.body.map( dimension => {
          console.log(dimension);
          return {
            id: dimension.id,
            nombre: dimension.nombre,
            //tipoEvaluacion: dimension.tipoEvaluacion,
            categorias: dimension.categorias,
            descripcion: dimension.descripcion,
            bloqueado : dimension.bloqueado
          };
        });
        this.dataSource.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
      });
    }

    openDialog(action, obj): void {
      const dialogRef = this.dialog.open(DialogBoxComponentDimension, {
        width: '100%',
        autoFocus: false,
        data: {action:action, obj:obj,dataSource:this.dataSource},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        if(result.dataSource!=null){
          this.dataSource = result.dataSource;
          this.dataSource.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
        }
        this.table.renderRows();
      });
    }

    OnePageChange(event: PageEvent) {
      this.basicSlice = event.pageSize;
      this.getElements(event.pageIndex);
    }

}
